import React from 'react';

function UnfoldIcon({ width = 24, height = 24, ...rest }) {
  // tslint:disable max-line-length
  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 24 24">
      <g>
        <path d="M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z" />
      </g>
    </svg>
  );
  // tslint:enable max-line-length
}

export default UnfoldIcon;
